import React, { useState, useEffect, useRef } from "react";
import "./login.scss";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import Loader from "../../hooks/loader";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useWeb3React } from "../../hooks/useWagmiCompat";
import useAuth from "../../hooks/useAuth";
import CuurentRound from "../../hooks/chinaFunction/round";
import Timer from "../../hooks/chinaFunction/timer";
import { saveAddress } from "@sharemint/sdk";
import { storeReferrer } from "@sharemint/sdk";
import Environment from "../../utils/Environment";
import { enrichRoundWithKind } from "../../utils/roundKind";
import { requestWithState } from "../../@api/requestWithState";
import useRecordEvent from "../../hooks/useRecordEvent";
import useWeb3ErrorToast from "../../utils/useWeb3ErrorToast";
import {
  clearWalletSession,
  isWalletSessionExpired,
  setWalletSession,
} from "../../utils/walletSession";
import { useEventSessionContext } from "../../contexts/EventSessionContext";
import { notifyInfo } from "../Toast";
import { persistSpecialUserFlag } from "../../utils/specialUser";

const Login = () => {
  const Presale = Environment?.presale;
  const { cuurentRound } = CuurentRound();
  const { timer } = Timer();
  const { recordEvent, initSession } = useRecordEvent();
  const { eventSessionId, setEventSessionId } = useEventSessionContext();
  const { handleError } = useWeb3ErrorToast();
  var now11 = new Date();
  let createdDate = now11?.getTime();
  // console.log(createdDate,'createdDate');
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const [currentRoundd, setCurrentRoundd] = useState(null);
  let currentTime1 = new Date();
  const { login, logout } = useAuth();
  const { account } = useWeb3React();
  const history = useHistory();
  const [loaderr, setLoarder] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show11, setShow11] = useState(false);
  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);

  const [show12, setShow12] = useState(false);
  const handleClose12 = () => setShow12(false);
  const handleShow12 = () => setShow12(true);

  const [showKaiModal, setShowKaiModal] = useState(false);
  const [showKaiLoadingModal, setShowKaiLoadingModal] = useState(false);
  const [showKaiGeneratedModal, setShowKaiGeneratedModal] = useState(false);
  const [isCodeCopied, setIsCodeCopied] = useState(false);

  const KAI_ACCESS_CODE = "4082920596";

  const handleCopyCode = async () => {
    navigator.clipboard.writeText(KAI_ACCESS_CODE);
    setIsCodeCopied(true);
    setTimeout(() => setIsCodeCopied(false), 2000);
    const metaData = {
      generatedAccessCode: true
    };
    await recordEvent(metaData);
  };

  const handleGenerateAccessCode = () => {
    setShowKaiModal(false);
    setShowKaiLoadingModal(true);
    setTimeout(() => {
      setShowKaiLoadingModal(false);
      setShowKaiGeneratedModal(true);
    }, 2500);
  };

  const [inputFeild1, setInputFeild1] = useState(null);
  const [inputFeild6, setInputFeild6] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [categoryScrollState, setCategoryScrollState] = useState(false);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [checkedNew, setCheckedNew] = useState(false);
  const [checkedNew1, setCheckedNew1] = useState(false);
  const [check, setChecked] = useState(false);
  const [niceName, setNicName] = useState(null);
  const [check3, setCheck3] = useState(false);

  const [isCodeValid, setIsCodeValid] = useState(true);
  const [codeSentOnce, setCodeSentOnce] = useState(false);
  const [isValidMail, setIsValidMail] = useState(true);
  const [isEmailVerified, setIsEmailVerified] = useState(null);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);

  const accountChangedRef = useRef(false);

  // const shouldShowLeaderModal = () =>
  //   (!inputFeild1 || !isCodeValid) && !localStorage.getItem("leaderModalSeen");

  // useEffect(() => {
  //   const handleMouseLeave = (e) => {
  //     if (e.clientY <= 0 && shouldShowLeaderModal()) {
  //       localStorage.setItem("leaderModalSeen", "true");
  //       handleShow12();
  //     }
  //   };

  //   document.addEventListener("mouseleave", handleMouseLeave);

  //   return () => {
  //     document.removeEventListener("mouseleave", handleMouseLeave);
  //   };
  // }, [inputFeild1, isCodeValid]);

  const userLogin = async () => {
    if (!isValidEmail(inputFeild6)) {
      setCheckedNew1(false);
      setIsValidMail(false);
      return;
    }
    // localStorage.setItem("email", inputFeild6);
    const isAcknowleged = await consentFormAck();
    if (!isAcknowleged) {
      // toast.error("Could not acknowledge at the moment.");
      return;
    }
    checkVerification();
    // window.location.assign("/buy");
  };

  const inputField1Handler1 = (e) => {
    setIsCodeValid(true);
    let value = e.target.value;
    setInputFeild1(value);
  };
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const inputField1Handler5 = (e) => {
    let value = e.target.value;
    setInputFeild6(value);
    setIsEmailVerified(null);
    setIsValidMail(true);
    setCheckedNew1(true);
  };
  // const inputField1Handler5 = (e) => {
  //   let value = e.target.value;
  //   if (!isValidEmail(value)) {
  //     setInputFeild6(value);
  //     setCheckedNew1(false);
  //   } else {
  //     setInputFeild6(value);
  //     setCheckedNew1(true);
  //   }
  // };

  useEffect(() => {
    storeReferrer();
    return () => { };
  }, []);

  const [timeshow, setTimeshow] = useState(false);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);

  const [showverify, setShowVerify] = useState(false);

  const [otp, setOtp] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);

  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const handleCloseVerify = (flag) => {
    setOtp("");
    setIsOtpValid(true);
    setShowVerify(false);
    setCodeSentOnce(false);
    setIsEmailVerified(null);
    setInputFeild6(null);
  };
  const handleShowVerify = () => setShowVerify(true);

  const callRecordEventAgreement = async (
    email,
    emailVerified = false,
    onlyEmailEvent = false,
  ) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode) return;

    const metaData = {
      ...(!onlyEmailEvent && {
        privateSaleAgreement: [
          {
            email,
            agreedToToS: cheked,
            agreedToNotUsIsrealCitizen: cheked1,
            agreedToReceiveMarketingEmail: cheked2,
            agreedOn: Date.now(),
          },
        ],
      }),
      ...(emailVerified && {
        emailWasVerified: true,
      }),
    };

    await recordEvent(metaData);
  };

  const consentFormAck = async () => {
    try {
      const config = {
        url: `${API_URL}logs/acknowledgements`,
        method: "POST",
        data: {
          email: inputFeild6,
          by: account.toLowerCase(),
          privateSale: Presale?.apiTag,
          acknowledged: true,
        },
      };
      const response = await axios(config);

      console.log("murtaza response ack", response);

      if (response?.data?.statusCode === 201) {
        return true;
      }
    } catch (error) {
      console.error("Error in consent acknowledgement:", error);
      if (
        error?.response?.data?.details?.[0]?.email ===
        '"email" must be a valid email'
      )
        setIsValidMail(false);
      return false;
    }
  };

  const checkVerification = async () => {
    try {
      setIsCheckingEmail(true);
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          by: account.toLowerCase(),
        },
      });
      setIsCheckingEmail(false);
      console.log(response, "Verification Response");
      if (response?.deta?.isVerified) {
        setIsEmailVerified(true);
        console.log("Verified fetched successfully:", response?.data);
        await callRecordEventAgreement(inputFeild6, true);
      } else {
        setIsEmailVerified(false);
        await callRecordEventAgreement(inputFeild6);
        console.log("User is not verified");
      }
    } catch (error) {
      setIsEmailVerified(false);
      console.error("Error checking verified:", error);
    } finally {
      setIsCheckingEmail(false);
    }
  };

  const [resendTimer, setResendTimer] = useState();
  useEffect(() => {
    let countdown;
    if (resendTimer > 0) {
      countdown = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [resendTimer, isResendDisabled]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!isValidEmail(inputFeild6) || isResendDisabled) {
      setIsValidMail(false);
      return;
    }

    try {
      const response = await requestWithState({
        url: `/emails/verify-email`,
        method: "POST",
        data: {
          email: inputFeild6,
          by: account.toLowerCase(),
          // country,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        setCodeSentOnce(true);
        toast.success("Verification code sent to your email", {
          className: "verification-toast",
          position: "top-right",
        });

        setShowOtpInput(true);

        // Start cooldown
        setIsResendDisabled(true);
        setResendTimer(10);
      } else if (response?.statusCode === 409) {
        toast.error("Email already exists");
      } else if (response?.statusCode === 403) {
        toast.error("Given wallet address is associated with existing email");
      }
    } catch (error) {
      console.error("Failed to send verification email:", error);
      // toast.error(error.message)
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email: inputFeild6,
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        await callRecordEventAgreement(inputFeild6, true, true);
        setIsEmailVerified(true);
        console.log("Email verified successfully");
        setIsOtpValid(true);
        handleCloseVerify(true);
        handleClose2();
        redirectTo();
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      let now = "";
      let time = "";
      let diff = "";
      if (currentTime < new Date(parseInt(currentRount?.startTime))) {
        now = new Date();
        time = new Date(parseInt(currentRount?.startTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
      } else if (
        currentTime > new Date(parseInt(currentRount?.startTime)) &&
        currentTime < new Date(parseInt(currentRount?.endTime))
      ) {
        now = new Date();
        time = new Date(parseInt(currentRount?.endTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
        // console.log(diff);
      }
      if (diff <= 0) {
        if (currentTime < new Date(parseInt(currentRount?.startTime))) {
          window.location.reload();
        }

        setTimeshow(true);

        clearInterval(interval);
      }
      const days = Math.floor(diff / (60 * 60 * 24));
      const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
      const mins = Math.floor((diff % (60 * 60)) / 60);
      const secs = Math.floor(diff % 60);
      setDay(days);
      setHour(hours);
      setMin(mins);
      setSec(secs);
    }, 1000);
    return () => clearInterval(interval);
  }, [currentRount]);

  const userLogin1 = async (e) => {
    // setLoarder(true);
    await axios
      .get(API_URL + "sale-rounds/users")
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        a.map((i) => {
          if (e == i?.round && i.privateSale == Presale?.apiTag) {
            setNicName(i.round);
          }
        });
        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder(false);
        // setLoarder(false);
      });
  };
  // const calucation = (e) => {
  //   // console.log(e,'imad');
  //   let dummy = [];
  //   let a = "";
  //   let indexx = "";
  //   let aaa = e.map((i, index) => {
  //     let tempLockedLending2 = "";
  //     if (
  //       currentTime > parseInt(i.startTime) &&
  //       currentTime < parseInt(i.endTime)
  //     ) {
  //       a = i;
  //       indexx = index + 1;
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     } else {
  //       let deff = currentTime - parseInt(i.startTime);
  //       tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
  //       dummy.push(tempLockedLending2);
  //     }
  //   });
  //   if (a) {
  //     // setPrice(a?.price/10**18)
  //     setCurrentRount(a);
  //     setCurrentRoundd(indexx);
  //     // console.log("roundhere", indexx)

  //     userLogin1(indexx);
  //     // setPrice(value?.price/10**18)
  //   } else if (dummy?.length > 0) {
  //     dummy.sort((a, b) => {
  //       return a?.diffrence - b?.diffrence;
  //     });
  //     setCurrentRount(dummy[0]);
  //     setCurrentRoundd(dummy[0]?.currentround);
  //     // console.log("roundhere", dummy[0]?.currentround)
  //     userLogin1(dummy[0]?.currentround);
  //     // setPrice(dummy[0]?.price/10**18)
  //   }
  // };

  // const roundData = async (e) => {
  //   // console.log(e,'eee');
  //   try {
  //     if (parseInt(e) <= 1) {
  //       // console.log('in if noor ',e);
  //       let c = await timer(e);

  //       if (c) {
  //         setCurrentRount(c);
  //         // setPrice(e?.price/10**18)
  //         setCurrentRoundd(e);
  //         userLogin1(e);

  //         setTimeout(() => {
  //           // console.log("Delayed for 1 second.");
  //           setLoarder(false);
  //         }, "1000");
  //         // setPrice(c.price/10**18)
  //         // console.log('nooor',c.price);
  //         // setCurrentTimer(c)
  //       }
  //     } else {
  //       let dummy = [];
  //       // console.log(e,'loooop bahis');
  //       for (let a = 1; a <= e; a++) {
  //         // console.log(a,'loooop');
  //         let c = await timer(a);
  //         dummy.push(c);
  //       }
  //       // console.log(dummy,'loooop');
  //       calucation(dummy);
  //     }
  //   } catch (err) {
  //     console.log(err, "erro in timer");
  //     setLoarder(false);
  //   }
  // };

  const roundData = async (e) => {
    try {
      if (parseInt(e) <= 1) {
        // Handle single round case
        const roundInfo = await timer(e);

        if (roundInfo) {
          const enriched = enrichRoundWithKind(roundInfo);
          setCurrentRount(enriched);
          localStorage.setItem("selectedRoundKind", enriched.roundKind);
          setCurrentRoundd(e);
          userLogin1(e);
          setTimeout(() => setLoarder(false), 1000);
        }
      } else {
        // Start from current round and go backwards to find active round
        let activeRound = null;
        let roundNumber = null;

        // Check rounds from current (e) down to 1
        for (let i = parseInt(e); i >= 1; i--) {
          const roundInfo = await timer(i);

          // Check if this round is currently active
          if (
            currentTime > parseInt(roundInfo.startTime) &&
            currentTime < parseInt(roundInfo.endTime)
          ) {
            activeRound = roundInfo;
            roundNumber = i;
            break; // Found active round, stop searching
          }

          // Store first round for fallback
          if (!activeRound) {
            activeRound = roundInfo;
            roundNumber = i;
          }
        }

        // If no active round found, find the closest one
        if (
          !activeRound ||
          currentTime < parseInt(activeRound.startTime) ||
          currentTime > parseInt(activeRound.endTime)
        ) {
          const allRounds = await fetchAllRounds(e);
          activeRound = findClosestRound(allRounds);
          roundNumber = activeRound.roundNumber;
        }

        updateRoundState(activeRound, roundNumber);
      }
    } catch (err) {
      console.log(err, "error in roundData");
      setLoarder(false);
    }
  };

  // Helper function to fetch all rounds if needed
  const fetchAllRounds = async (maxRound) => {
    const rounds = [];
    for (let i = 1; i <= maxRound; i++) {
      const roundInfo = await timer(i);
      rounds.push({ ...roundInfo, roundNumber: i });
    }
    return rounds;
  };

  // Helper function to find closest round
  const findClosestRound = (rounds) => {
    let closestRound = null;
    let minDiff = Infinity;

    rounds.forEach((round) => {
      const diff = Math.abs(currentTime - parseInt(round.startTime));
      if (diff < minDiff) {
        minDiff = diff;
        closestRound = round;
      }
    });

    return closestRound;
  };

  // Helper function to update state
  const updateRoundState = (roundInfo, roundNumber) => {
    const enriched = enrichRoundWithKind(roundInfo);
    setCurrentRount(enriched);
    localStorage.setItem("selectedRoundKind", enriched.roundKind);
    setCurrentRoundd(roundNumber);
    userLogin1(roundNumber);
    setTimeout(() => setLoarder(false), 1000);
  };

  const [show2, setShow2] = useState(false);

  const handleClose2 = () => {
    setShow2(false);
    setCheked(false);
    setCheked1(false);
    setCategoryScrollState(false);
    setCheckedNew(false);
  };

  const redirectTo = () => {
    window.location.assign("/buy");
  };

  const joinTelegramHandler = () => {
    const weChatShareUrl = "https://t.me/GemsOfficialCommunity";

    // Open the WeChat share link in a new window
    window.open(weChatShareUrl, "_blank");
    handleClose12();
  };

  const handleGemsClick = () => {
    const gemsLanding = "/buy";
    window.location.reload(gemsLanding)
  }

  const handleShow2 = () => setShow2(true);
  const [cheked, setCheked] = useState(false);
  const [cheked1, setCheked1] = useState(false);
  const [cheked2, setCheked2] = useState(false);

  const inputField1Handler2 = (e) => {
    if (e.target.checked == true) {
      setCheked(true);
    } else {
      setCheked(false);
      setCheked1(false);
    }
  };
  const inputField1Handler3 = (e) => {
    if (e.target.checked == true) {
      setCheked1(true);
    } else {
      setCheked1(false);
    }
  };
  const inputField1Handler4 = (e) => {
    if (e.target.checked == true) {
      setCheked2(true);
    } else {
      setCheked2(false);
    }
  };

  const inputFieldHandler6 = (e) => { };

  const callRecordEvent = async (accessCode, status) => {
    const metaData = {
      codeVerifyStep: [
        {
          accessCode,
          status,
          timeAttempted: Date.now(),
        },
      ],
    };
    await recordEvent(metaData);
  };

  const apiCheck = async (e) => {
    e?.preventDefault();
    if (inputFeild1 == 8707989948) {
      // console.log(value,'valuevaluevalue');
      localStorage.setItem("sharemint", inputFeild1);
    } else {
      localStorage.removeItem("sharemint");
    }
    const currentTime = new Date();
    setLoarder(true);
    const data = {
      accessCode: inputFeild1,
      privateSale: Presale?.apiTag,
    };
    await axios
      .post(API_URL + "users/verify-code", data)
      .then(async (res) => {
        console.log(res.data.data.data.code, "res");
        let dd = JSON.stringify(res.data.data.limit);
        localStorage?.setItem("oobjj", dd);
        localStorage?.setItem(
          "accessCode",
          res?.data?.data?.data?.code?.accessCode,
        );
        localStorage?.setItem("role_ins", res?.data?.data?.data?.code?.role);
        localStorage?.setItem(
          "price_ins",
          res?.data?.data?.data?.allowedPrice?.tokenPrice,
        );
        persistSpecialUserFlag(res?.data?.data?.data?.code?.isSpecialCode);
        localStorage?.setItem(
          "timeeee",
          new Date(currentTime.getTime() + 24 * 3600000),
        );
        await callRecordEvent(inputFeild1.trim(), "verified");
        setLoarder(false);
        // handleShow2();
        redirectTo();
        setCategoryScrollState(true);
      })
      .catch(async (err) => {
        await callRecordEvent(inputFeild1.trim(), "invalid");

        console.log(err, "err");
        setIsCodeValid(false);
        // toast.error("Access code is not valid");
        setLoarder(false);
      });
  };

  const apiCheck11 = async (eee) => {
    if (eee == 8707989948) {
      // console.log(value,'valuevaluevalue');
      localStorage.setItem("sharemint", eee);
    } else {
      localStorage.removeItem("sharemint");
    }
    const currentTime = new Date();
    setLoarder(true);
    const data = {
      accessCode: eee,
      privateSale: Presale?.apiTag,
    };
    await axios
      .post(API_URL + "users/verify-code", data)
      .then(async (res) => {
        console.log(res.data.data.data.code, "res");
        let dd = JSON.stringify(res.data.data.limit);
        localStorage?.setItem("oobjj", dd);
        localStorage?.setItem(
          "accessCode",
          res?.data?.data?.data?.code?.accessCode,
        );
        localStorage?.setItem("role_ins", res?.data?.data?.data?.code?.role);
        localStorage?.setItem(
          "price_ins",
          res?.data?.data?.data?.allowedPrice?.tokenPrice,
        );
        persistSpecialUserFlag(res?.data?.data?.data?.code?.isSpecialCode);
        localStorage?.setItem(
          "timeeee",
          new Date(currentTime.getTime() + 24 * 3600000),
        );
        await callRecordEvent(eee.trim(), "verified");
        setLoarder(false);
        // handleShow2();
        redirectTo()
        setCategoryScrollState(true);
      })
      .catch(async (err) => {
        console.log(err, "err");
        await callRecordEvent(eee.trim(), "invalid");
        toast.error("Access code is not valid");
        setLoarder(false);
      });
  };

  const handleCategoryScroll = () => {
    // console.log("hitting handle Scroll ");

    const element = document.querySelector(".scrolltext");
    if (
      element.scrollTop + element.clientHeight >= element.scrollHeight - 5 &&
      !isCategoryLoading
    ) {
      setIsCategoryLoading(true);
    }
  };

  useEffect(() => {
    if (isCategoryLoading) {
      // fetchCategoriesData();
      sxcrolll();
    }
    const scrollableElement = document.querySelector(".scrolltext");

    // console.log("scrolltext Element: ", scrollableElement);

    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleCategoryScroll);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleCategoryScroll);
      }
    };
  }, [isCategoryLoading, categoryScrollState]);

  const sxcrolll = () => {
    // console.log('completed');
    setIsCategoryLoading(false);
    setCheckedNew(true);
  };

  const firstTimeData = async () => {
    try {
      setLoarder(true);
      let b = await cuurentRound();

      if (b) {
        // setCurrentRoundd(b)
        roundData(b);
      }
    } catch (err) {
      console.log(err.message);
      setLoarder(false);
    }
  };

  useEffect(() => {
    firstTimeData();
    if (!account) return;

    const stored = localStorage.getItem("walletEvent");
    const walletEvent = stored ? JSON.parse(stored) : null;

    const shouldFire =
      !walletEvent || walletEvent.account !== account.toLowerCase();

    if (shouldFire) {
      accountChangedRef.current = true;
      if (stored) {
        notifyInfo(
          "Account changed. Your session has been updated to your current wallet address.",
        );

        // toast.info(
        //   "Account changed. Your session has been updated to your current wallet address.",
        //   { toastId: "account-swap" },
        // );
      }
      setWalletSession();
      callRecordEventWalletConnect("connected");
    }
  }, [account]);

  useEffect(() => {
    if (!account) return;

    if (accountChangedRef.current) {
      accountChangedRef.current = false; // reset for next time
      return;
    }

    const checkSession = async () => {
      if (isWalletSessionExpired()) {
        const connectorId = localStorage.getItem("connectorId");

        await logout(connectorId);
        clearWalletSession();

        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");

        notifyInfo(
          "Your session has timed out. Please reconnect wallet to continue your purchase.",
          "wallet-session-expired",
        );

        // toast.warning(
        //   "Your session has timed out. Please reconnect wallet to continue your purchase.",
        //   { toastId: "wallet-session-expired" },
        // );
      }
    };

    checkSession();
  }, [account]);

  const callRecordEventWalletConnect = async (status) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode || !account) return;

    const metaData = {
      connectWallet: [
        {
          walletAddress: account.toLowerCase(),
          status,
          connectedAt: Date.now(),
        },
      ],
    };

    await recordEvent(metaData);

    localStorage.setItem(
      "walletEvent",
      JSON.stringify({
        logged: true,
        presale: Presale.apiTag,
        account: account.toLowerCase(),
      }),
    );
  };

  const connectMetaMask1 = async () => {
    if (account) {
      try {
        const connectorId = window.localStorage.getItem("connectorId");
        await callRecordEventWalletConnect("disconnected");
        await logout(connectorId);
        clearWalletSession();
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose1();
        setWalletSession();
        setChecked(true);
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      try {
        await callRecordEventWalletConnect("disconnected");
        await logout("walletconnect");
        clearWalletSession();
        localStorage.clear();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("walletconnect");
        handleClose1();
        setChecked(true);
        setWalletSession();
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
        handleError(err);
      }
    }
  };

  // useEffect(() => {
  //   if (check) {
  //     clickAlready();
  //   }
  // }, [account, cheked]);
  const clickAlready = () => {
    setLoarder(true);
    nftMainArryHandler2latestFromAdmin();
    // console.log(account,'account');
  };
  const nftMainArryHandler2latestFromAdmin = async () => {
    setLoarder(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
          where: {by: "${account}"}) {
            type
            transactionHash
            tokenSelected
            tokenPurchased
            tokenPrice
            token
            roundPrice
            round
            nftAmounts
            id
            code
            by
            blockTimestamp
            amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.privateSaleGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        let a = response?.data?.data?.purchases;
        if (a.length > 0) {
          window.location.assign("/claim");
        } else {
          toast.warning("No Claim Found");
        }
        // instittion(a);

        // settotalArry(a);
        setLoarder(false);
        // ClaimAll111();
        // settotalArry(response?.data?.data?.investments);
        // instittion(response?.data?.data?.investments)
      })
      .catch(function (error) {
        setLoarder(false);
        console.log(error, "error");
      });
  };
  const instittion = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {
        purchases(
          orderBy: blockTimestamp
    orderDirection: desc
        where: {recipient: "${account}"}) {
          transactionHash
    tokenSelected
    tokenPurchased
    tokenPrice
    token
    recipient
    price
    id
    code
    by
    blockTimestamp
    amountPurchased
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: "https://api.studio.thegraph.com/query/63987/leia-institution/1",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        setLoarder(false);
        // console.log(response, 'response?.data?.data?.investments mainn1 sddasasa');
        let a = response?.data?.data?.purchases;
        let c = e.concat(a);
        // console.log(c,'ccccc');
        if (c.length > 0) {
          window.location.assign("/claim");
        } else {
          toast.warning("No Claim Found");
        }
        // settotalArry(a);
        // setMainLoader1(false);
        // ClaimAll111();
        // settotalArry(response?.data?.data?.investments);
        // instittion(response?.data?.data?.investments)
      })
      .catch(function (error) {
        setLoarder(false);
        console.log(error, "error");
      });
  };

  useEffect(() => {
    setLoarder(true);
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get("utm_source");

    let session;
    session = initSession(utmSource);

    const code = params.get("leader");
    if (code && session) {
      apiCheck11(code);
    } else {
      setLoarder(false);
    }
  }, []);

  return (
    <>
      {loaderr && <Loader />}
      <section className="login-screen">
        <video
          className="main-banner-video"
          muted="muted"
          playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo"
        >
          <source src="/loginvideo.mp4" type="video/mp4" />
        </video>
        <span className="bannershade"></span>
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid login-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="upper-logo ">
          <div className="container">
            <div className=" set-flex">
              <img src="\logo.svg" alt="img" className="img-fluid" onClick={handleGemsClick} style={{ cursor: "pointer" }} />
              {/* {!account ? (
                <a onClick={handleShow1}>Already Purchased?</a>
              ) : (
                <a onClick={clickAlready}>Already Purchased?</a>
              )} */}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="timermain">
            <div className="timerleft">
              <div className="mainiconimg">
                <img
                  src={Presale?.image}
                  alt="iconimginner"
                  className="iconimginner"
                />
              </div>
              <div className="mainicontexts">
                <h6 className="timerhead">{Presale?.name}</h6>
                <p className="timerpara">${Presale?.symbol}</p>
                {/* <p className="timerpara">Round  {niceName} starts on:</p> */}
              </div>
            </div>
            <div className="forflexmain">
              {currentTime < new Date(parseInt(currentRount?.startTime)) ? (
                <p className="timerpara">Round {niceName} Starts in:</p>
              ) : (
                <>
                  {currentTime > new Date(parseInt(currentRount?.startTime)) &&
                    currentTime < new Date(parseInt(currentRount?.endTime)) ? (
                    <p className="timerpara">Round {niceName} Ends in:</p>
                  ) : (
                    ""
                  )}
                </>
              )}
              {timeshow ? (
                <p className="timerended"> Sale ended!</p>
              ) : (
                <p className="innertimertext">
                  {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M :{" "}
                  {sec ? sec : 0}S
                </p>
              )}
            </div>
          </div>

          <form onSubmit={(e) => apiCheck(e)} className="w-100">
            <div className="bottom-card">
              {/* <img
              src="\assets\card-logo.svg"
              alt="img"
              className="img-fluid scvtsvctsc"
            /> */}
              <h6>Enter access code to continue</h6>
              <div className="material-textfield">
                <input
                  onChange={inputField1Handler1}
                  value={inputFeild1}
                  type="text"
                  placeholder="Enter access code"
                  className={isCodeValid ? "" : "errorinput"}
                />
                {!isCodeValid && (
                  <p className="errorpara">Invalid access code</p>
                )}
              </div>
              {inputFeild1 ? (
                <button className=" newClass" type="submit">
                  Continue
                </button>
              ) : (
                <button className="btn-continue" type="button">
                  Continue
                </button>
              )}

              <p className="leaderpara">
                Need a leader code?{" "}
                <span
                  onClick={handleShow11}
                  style={{ cursor: "pointer" }}
                  className="greenpara"
                >
                  Click here
                </span>
              </p>
            </div>
          </form>
        </div>
        <div className="loginfooter">
          <div className="custom-container">
            <div className="innerloginfooter">
              <img src="/logo.svg" alt="logoimg" className="logoimg" />
              <p className="footerpara">©2026 GEMS. All rights reserved</p>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="connectwallet-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="twice-btns">
            <button>
              <img src="\assets\metamask.svg" alt="img" className="img-fluid" />
              <h6>Metamask</h6>
            </button>
            <button>
              <img
                src="\assets\walletconnect.svg"
                alt="img"
                className="img-fluid"
              />
              <h6>WalletConnect</h6>
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="connectwallet-modal nooreee"
        show={show2}
        onHide={handleClose2}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              className="mr-2"
            >
              <rect y="0.5" width="24" height="24" rx="4" fill="#E88F35" />
              <path
                d="M10.0001 2.5L13.4199 4.40802L13.5063 17.6429L10.0866 15.7348L10.0001 2.5Z"
                fill="white"
              />
              <path
                d="M10.0001 17.604L13.4199 19.512L13.5063 21.604L10.0866 19.696L10.0001 17.604Z"
                fill="white"
              />
            </svg>
            PRIVATE SALE AGREEMENT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="darktext">
            <div className="scrolltext">
              <p className="darkparaupper text-center">Terms Of Service</p>
              <p className="darkpara text-center">
                Last Updated: [15.5.2026]
              </p>
              <p className="darkpara">
                1.
                <span className="headingtext formarginleft">Introduction</span>
              </p>
              <p className="darkpara">
                These Terms of Service, together with any other agreements or
                terms incorporated by reference, including our Privacy Policy
                (available here) (these “Terms”) govern your access to and use
                of the Gems platform, available at https://gems.vip/, (the
                “Platform”), owned and operated by Gems Labs Limited d/b/a Gems
                (“Gems,” “we,” “us”, or “our”) and any software, tools,
                features, or functionalities provided on or in connection with
                our services; including without limitation using our services,
                at your own discretion, to view, explore and or/purchase
                blockchain tokens (the “Tokens”) associated with various
                projects which may be made available on our Platform from time
                to time (collectively, the “Service”).{" "}
              </p>
              <p className="darkpara">
                For purposes of these Terms, “user”, “you”, and “your” mean you
                as the user of the Service. If you use the Service on behalf of
                a company or other entity then “you” includes you and that
                entity, and you represent and warrant that (a) you are an
                authorized representative of the entity with the authority to
                bind the entity to these Terms, and (b) you agree to these Terms
                on the entity’s behalf.
              </p>
              <p className="darkpara">
                BY USING THE PLATFORM AND/OR SERVICE, YOU AGREE TO BE BOUND BY
                THESE TERMS AND ALL OF THE TERMS INCORPORATED HEREIN BY
                REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT
                ACCESS OR USE THE PLATFORM AND/OR SERVICE.
              </p>
              <p className="darkpara">
                Please refer to our Privacy Policy for information about how we
                collect, use, and share information from and/or about you (“Your
                Data”). By submitting Your Data through our Service, you agree
                to the terms of our Privacy Policy and you expressly consent to
                the collection, use, and disclosure of Your Information in
                accordance with the Privacy Policy.
              </p>
              <p className="darkpara">
                Gems is not a wallet provider, exchange, broker, dealer,
                financial institution, payments processor, money services
                business, or creditor. Gems showcases curated blockchain
                projects (each, a “Project”) and allows you to participate in
                the sale of their Tokens. We do not have custody or control over
                the Tokens or blockchains you are interacting with and we do not
                execute or effectuate purchases, transfers, or sales of Tokens.
                To use our Service, you must use a third-party wallet which
                allows you to engage in transactions on blockchains and you are
                responsible for obtaining and maintaining the security of such
                wallet and its keys.
              </p>
              <p className="darkpara">
                Gems is not a party to any agreement between you and the
                Project. You bear full responsibility for engaging with or
                purchasing of Tokens from to any Project and acquiring their
                Tokens, which in each case, may only be facilitated by acquiring
                a valid referral code from third-party promoters (each, a
                “Leader”) and we make no claims, guarantees, or recommendations
                about the identity, legitimacy, functionality, or authenticity
                of Leaders or Tokens (and any Projects or teams associated with
                such Tokens) visible on the Service.
              </p>
              <p className="darkpara">
                Because we have a growing number of services, we may, from time
                to time, provide additional terms for specific services (and
                such services are deemed part of the “Service” hereunder and
                shall also be subject to these Terms). Those additional terms
                and conditions, which are available with the relevant service,
                then become part of your agreement with us if you use those
                services. In the event of a conflict between these Terms and any
                additional applicable terms we may provide for a specific
                service, such additional terms shall control for that specific
                service.
              </p>
              <p className="darkpara">
                Gems reserves the right to change or modify these Terms at any
                time and in our sole discretion. If we make material changes to
                these Terms, we will use reasonable efforts to provide notice of
                such changes, such as by providing notice through the Platform
                or updating the “Last Updated” date at the beginning of these
                Terms. By continuing to access or use the Service, you confirm
                your acceptance of the revised Terms and all of the terms
                incorporated therein by reference effective as of the date these
                Terms are updated. It is your sole responsibility to review the
                Terms from time to time to view such changes and to ensure that
                you understand the terms and conditions that apply when you
                access or use the Service. We further reserve the right in our
                sole discretion to modify, suspend, or discontinue, temporarily
                or permanently, the Service (or any features or parts thereof)
                at any time and without liability as a result.
              </p>
              <p className="darkpara">
                2.
                <span className="headingtext formarginleft">
                  Accessing the Service
                </span>
              </p>
              <p className="darkpara">
                Your blockchain address functions as your identity on Gems.
                Accordingly, you will need a blockchain address and a
                third-party wallet to access the Service. Your account on the
                Platform (“Account”) will be associated with your linked
                blockchain address and will display the Tokens for that
                blockchain address (and, if applicable, any content associated
                with such Tokens). By using your wallet in connection with the
                Service, you agree that you are using that wallet under the
                terms and conditions of the applicable provider of the wallet.
                Wallets are not operated by, maintained by, or affiliated with
                Gems, and Gems does not have custody or control over the
                contents of your wallet and has no ability to retrieve or
                transfer its contents. Gems accepts no responsibility for, or
                liability to you, in connection with your use of a wallet and
                makes no representations or warranties regarding how the Service
                will operate with any specific wallet. You are solely
                responsible for keeping your wallet secure and you should never
                share your wallet credentials or seed phrase with anyone. If you
                discover an issue related to your wallet, please contact your
                wallet provider. Likewise, you are solely responsible for your
                Account and any associated wallet and we are not liable for any
                acts or omissions by you in connection with your Account or as a
                result of your Account or wallet being compromised. You agree to
                immediately notify us if you discover or otherwise suspect any
                security issues related to the Service or your Account, by
                sending an email to:{" "}
                <a href="mailto: Info@gems.vip">Info@gems.vip</a>.
              </p>
              <p className="darkpara">
                You also represent and warrant that you will comply with all
                applicable laws (e.g., local, state, federal and other laws) in
                connection with using the Service. In order to comply with our
                legal obligations and keep our users and platform safe, we may
                need to restrict, suspend, or terminate your access to the
                Service. You acknowledge that Gems is under no obligation to
                disclose the details of its decision to take such action with
                you.
              </p>
              <p className="darkpara">
                Without limiting the foregoing, by using the Service, you
                represent and warrant that:
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> You are
                not, and have not been involved in any type of activity
                associated with money laundering or terror financing, nor
                violated any provision of the U.S. Foreign Corrupt Practices Act
                of 1977, as amended, the UK Bribery Act (2010), or any other
                applicable anti-corruption or anti bribery legislation, nor were
                you ever subject, to any investigation by, or have received a
                request for information from any governmental body relating to
                corruption or bribery under any statute and you hereby consent
                to Gems running any checks or enquiries with third parties and
                you waive any privacy or other right in connection therewith and
                acknowledge that any breach of this representation by you will
                entitle Gems to terminate these Terms with immediate effect;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You have
                carefully reviewed, understand, and accept the various risks of
                entering into these Terms, including, but not limited to, the
                risks detailed in Section 8, below;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> You have
                not relied on any representations or warranties made by Gems or
                any representative thereof, including, but not limited to,
                conversations of any kind, whether through oral or electronic
                communication, or any whitepaper or similar document;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> You are
                not a citizen, resident, or an entity incorporated in a
                geographic area in which the purchase, access to, or use of the
                Tokens is prohibited by applicable law, decree, regulation,
                treaty, or administrative act;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries are located in, resident in,
                or incorporated under the laws of Afghanistan, Belarus, Burundi,
                Central African Republic, Congo (the Democratic Republic of the
                Congo), Cuba, Guinea, Guinea-Bissau, Haiti, Hong Kong, Iran,
                Iraq, the Democratic People's Republic of Korea (North Korea),
                Lebanon, Libya, Mali, Myanmar (Burma), Nicaragua, Somalia, South
                Sudan, Sudan, Syria, Taiwan, Venezuela, Western Sahara, Yemen,
                Zimbabwe; the Krim, Donetsk, Kherson and Luhansk regions of
                Ukraine, the United States of America or any jurisdiction which
                is the target of such comprehensive, country-wide or
                territory-wide Sanctions as currently apply to the
                aforementioned countries or any country or territory that has
                been designated as non-cooperative with international anti-money
                laundering principles or procedures by an intergovernmental
                group or organization, such as the Financial Action Task Force
                on Money Laundering (“FATF”) (each, a “Restricted
                Jurisdiction”). For the avoidance of doubt, the inclusion of
                Hong Kong as a Restricted Jurisdiction is absolute and
                unconditional. Notwithstanding Gems’ selection of Hong Kong law
                and the courts of Hong Kong as the governing law and exclusive
                forum under Section 12 (or any successor provision), persons
                and entities located in, resident in, or incorporated under the
                laws of Hong Kong are strictly prohibited from accessing or
                using the Service, and Gems’ choice of Hong Kong solely as the
                governing-law and dispute-resolution forum shall not be
                construed as authorizing, permitting, or implying access to the
                Service by any such person or entity.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is the target of any Sanctions
                laws, regulations, embargoes, or restrictive measures (the
                “Sanctions”), as amended from time to time, administered,
                enacted, or enforced by: the United Nations, the United States
                of America, the European Union or any Member State thereof, the
                United Kingdom or the respective Governmental Authorities of any
                of the foregoing responsible for administering, enacting or
                enforcing Sanctions, including without limitation, OFAC, the US
                Department of State or the United Kingdom Treasury (the
                “Sanctions Authority”);
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is listed on any of the
                following lists (each a “Sanctions List”): the Consolidated
                United Nations Security Council Sanctions List; the Specially
                Designated Nationals and Blocked Persons List or the Sectoral
                Sanctions Identification List maintained by the US Office of
                Foreign Assets Control (OFAC); the Consolidated List of Persons,
                Groups and Entities subject to EU Financial Sanctions; the
                Consolidated List of Financial Sanctions Targets or List of
                persons subject to restrictive measures in view of Russia's
                actions destabilizing the situation in Ukraine, maintained by
                the United Kingdom Treasury or any similar list maintained by,
                or public announcement of sanctions made by, any other Sanctions
                Authority.;
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> Neither
                you, nor any of your affiliates, shareholders, direct or
                indirect owners, or beneficiaries is owned or controlled by, or
                acting on behalf of or for the benefit of, any person on a
                Sanctions List or who is a citizen, resident, or incorporated in
                any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> You
                represent to Gems that you purchase the Tokens as utility
                tokens, in order to use them in the Project upon its launch, and
                not as an investment, a security, a financial product or an
                instrument that may be expected to accrue value, have secondary
                market, be sold, traded or have any utility, usage, value or
                usability other than its utility in the Project.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span> You
                covenant that any amounts used to purchase Tokens of the various
                Projects listed on the Platform will not be sourced from assets,
                funds, or accounts located in any Restricted Jurisdiction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">k.</span> You agree
                that, in accordance with Gems’ internal compliance and risk
                management protocols, where Gems has any reason to suspect that
                any of the representations and warranties in this Section 2
                (including any of items a through l above) is or may be
                inaccurate, incomplete, or misleading, or that your continued
                access to the Service would or may breach any applicable law,
                sanctions program, or anti-money-laundering requirement, Gems
                shall immediately suspend or terminate your Account and your
                access to the Service, and shall take any further action it
                deems necessary or appropriate to comply with applicable law.
                Gems shall be entitled to require you to provide any
                information or documentation, including identifying
                documentation about yourself, your Account, the funds used by
                you as part of the Service, and any other relevant information,
                and your continued access to the Service shall be conditioned
                upon your timely provision of such information and
                documentation to Gems’ satisfaction.
              </p>

              <p className="darkpara">
                <span className="headingtext formarginleft">l.</span> Any
                information provided by you shall be at all times complete,
                accurate and not misleading.
              </p>

              <p className="darkpara">
                Finally, by using the Service, you understand the importance of
                DYOR – doing your own research. You bear full responsibility for
                verifying the authenticity, legitimacy, identity, and other
                details about any Token or Project that you view or otherwise
                interact with in conjunction with our Service. We make no
                claims, guarantees or recommendations about the identity,
                legitimacy, or authenticity of any Token, Project, or account on
                the Service.
              </p>
              <p className="darkpara">
                WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, YOU ASSUME ALL
                RISK AND LIABILITY FOR THE RISKS OF ENTERING INTO THESE TERMS
                AND THE RESULTS OBTAINED BY THE USE OF THE TOKENS AND REGARDLESS
                OF ANY ORAL OR WRITTEN STATEMENTS MADE BY GEMS, ANY GEMS
                ASSOCIATED PERSON OR ANY GEMS REPRESENTATIVE, INCLUDING IN THE
                FORM OF TECHNICAL ADVICE OR OTHERWISE, RELATED TO THE USE OF THE
                TOKENS.
              </p>
              <p className="darkpara">
                3.<span className="headingtext formarginleft">Ownership</span>
              </p>
              <p className="darkpara">
                The Service, including its “look and feel” (e.g., text,
                graphics, images, logos, page headers, button icons, urls, and
                scripts), proprietary content, information and other materials,
                and all content and other materials contained therein,
                including, without limitation, the Gems logo and all designs,
                text, graphics, pictures, data, software, sound files, other
                files, and the selection and arrangement thereof are the
                proprietary property of Gems or our affiliates, licensors, or
                users, as applicable, and you agree not to take any action(s)
                inconsistent with such ownership interests. We and our
                affiliates, licensors, and users, as applicable, reserve all
                rights in connection with the Service and its content,
                including, without limitation, the exclusive right to create
                derivative works.
              </p>
              <p className="darkpara">
                Gems’s name, logo, trademarks, and any Gems product or service
                names, designs, logos, and slogans are the intellectual property
                of Gems or our affiliates or licensors and may not be copied,
                imitated or used, in whole or in part, without our prior written
                permission in each instance. You may not use any metatags or
                other “hidden text” utilizing “Gems” or any other name,
                trademark or product or service name of Gems or our affiliates
                or licensors without our prior written permission. In addition,
                the “look and feel” of the Service constitutes the service mark,
                trademark or trade dress of Gems and may not be copied, imitated
                or used, in whole or in part, without our prior written
                permission.
              </p>
              <p className="darkpara">
                All other third-party trademarks, registered trademarks, and
                product names mentioned on the Service or contained in the
                content linked to or associated with any Tokens displayed on the
                Service are the property of their respective owners and may not
                be copied, imitated or used, in whole or in part, without the
                permission of the applicable intellectual property rights
                holder. Reference to any products, services, processes or other
                information by name, trademark, manufacturer, supplier or
                otherwise does not constitute or imply endorsement, sponsorship,
                or recommendation by Gems.
              </p>
              <p className="darkpara">
                To the extent You provide us any feedback, comments or
                suggestions ("Feedback"), you grant us a royalty-free, fully
                paid up, worldwide, perpetual and irrevocable license to
                incorporate the Feedback into the Services or any of our current
                or future products or services.
              </p>
              <p className="darkpara">
                Gems does not have ownership, custody, or control of Tokens or
                the smart contracts deployed by third parties. Creators of these
                Tokens or smart contracts are solely responsible for their
                operation and functionality.
              </p>
              <p className="darkpara">
                You are hereby granted a limited, nonexclusive, non
                transferable, non sublicensable, and personal license to access
                and use the Service provided, however, that such license is
                subject to your compliance with these Terms.
              </p>
              <p className="darkpara">
                The Tokens will be claimed by you at a later date, to be
                communicated via the Service. You are responsible for making the
                claim. Tokens that are not claimed within the claim window
                specified by Gems on the Platform (the “Claim Window”) shall be
                permanently void and forfeited, and you shall have no further
                right, title, or interest in any such unclaimed Tokens or in any
                proceeds, value, or compensation related thereto. The Claim
                Window, including its start date, end date, and any extensions
                or modifications, shall be notified to you through the Platform
                (and/or by such other means as Gems may reasonably elect,
                including email to the address associated with your Account),
                and any such notification shall be deemed incorporated by
                reference into, and shall be a binding part of, these Terms.
                Gems may, in its sole discretion, set a default Claim Window of
                six (6) months from the date the claim is announced and made
                available on the Platform where no other timeframe is
                specified. We may request additional information, as well as
                KYC, upon the claim and facilitation thereof may be contingent
                on providing such information to us or any third party, in full.
              </p>
              <p className="darkpara">
                We further reserve the right not to accept any purchase of
                Tokens which does not comply with our terms of use, or that we
                otherwise deem, at our sole and final discretion, incompatible
                with applicable laws, regulations, project requirements, carry
                high level of risk, origin from Restricted Jurisdictions or from
                Purchasers included in Sanctioned Lists. Each Purchaser may be
                required, at our sole and final discretion, to undergo a KYC
                process and to provide additional information and documents for
                such purpose, and each transaction may undergo a KYT screening.
                Users and transactions that will fail to meet our requirements
                may, at our sole discretion, not be able to claim the Tokens,
                and the funds used for the Purchase of Tokens may be confiscated
                and seized or refunded to you, at our sole discretion. For the
                avoidance of doubt, Gems shall exercise any right of
                confiscation or seizure under this Section 3 strictly in
                compliance with applicable anti-money-laundering,
                counter-terrorist-financing, and sanctions laws, regulations,
                and reporting obligations, and any such confiscation or seizure
                shall be limited to circumstances in which a refund to you is
                legally prohibited, operationally impossible, or would itself
                violate applicable law (including, without limitation, where
                the funds are subject to a freezing order, blocking obligation,
                or required report to a competent regulator or law-enforcement
                authority). Where a refund is legally permissible and
                operationally feasible, Gems shall use commercially reasonable
                efforts to return the applicable funds to the source from which
                they were received, subject to deduction of any unrecoverable
                transaction, network, or third-party costs. Nothing in this
                Section 3 shall be construed to require Gems to take any action
                that would itself constitute a violation of applicable law.
              </p>
              <p className="darkpara">
                4.
                <span className="headingtext formarginleft">
                  Third-Party Content, Agreements, and Services
                </span>
              </p>
              <p className="darkpara">
                As a web3 launch pad, Gems helps you explore and purchase
                utility Tokens to various third party blockchain Projects and
                purchase the Project’s Tokens prior to the official launch of
                the Tokens, possibly at a discounted rate compared to the
                initial launch price of the Tokens. Gems is not the issuer of
                any of the tokens sold or otherwise made available on its
                Platform (except the $GEMS token) and makes no representation
                regarding the Projects, their Tokens, their teams or anyone
                associated therewith, including any content associated with the
                project and/or the Tokens displayed on the Service, and you bear
                responsibility for verifying the legitimacy, authenticity, and
                legality of the Tokens that you purchase.
              </p>
              <p className="darkpara">
                These Terms solely govern the use of our Service. There may be
                terms and conditions that apply to the Tokens' themselves set
                directly between buyers, sellers, and/or creators with respect
                to the Token including with respect to the use of the Token
                content and rights and obligations associated with a given Token
                ("Project Terms"). For example, when you click to get more
                details about any of the Tokens visible on Gems, you may notice
                a third-party link to Project Terms governing the use of the
                Token that you will be required to comply with. Gems does not
                set the Project Terms and is not party to any such Project
                Terms, which are solely between you and the Project.
              </p>
              <p className="darkpara">
                Projects are solely responsible for determining and establishing
                the price of a Token, inclusive of any applicable tax.
              </p>
              <p className="darkpara">
                For its Service, Gems may receive certain fees. Gems does not
                set, collect, or determine other applicable costs, fees, and
                expenses associated with buying and selling a Token, including
                but not limited to any Project earnings, gas, or transaction
                fees. These costs, fees, and expenses are paid directly to the
                Project and/or the Leader, blockchain validator, or other third
                party, as applicable. Because these costs, fees, and expenses
                are not collected by Gems, it cannot refund them.
              </p>
              <p className="darkpara">
                The Service may also contain links or functionality to access or
                use third-party websites (“Third-Party Websites”) and
                applications (“Third-Party Applications”), or otherwise display,
                include, or make available content, data, information, services,
                applications, or materials from third parties (“Third-Party
                Materials”). When you click on a link to, or access and use, a
                Third-Party Website or Third-Party Application, though we may
                not warn you that you have left our Service, you are subject to
                the terms and conditions (including privacy policies) of another
                website or destination. Such Third-Party Websites, Third-Party
                applications, and Third-Party Materials are not under the
                control of Gems, and may be “open” applications for which no
                recourse is possible. Gems is not responsible or liable for any
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials. Gems provides links to these Third-Party Websites and
                Third-Party applications only as a convenience and does not
                review, approve, monitor, endorse, warrant, or make any
                representations with respect to Third-Party Websites or
                Third-Party applications, or their products or services or
                associated Third-Party Materials. You use all links in
                Third-Party Websites, Third-Party applications, and Third-Party
                Materials at your own risk.
              </p>
              <p className="darkpara">
                5.
                <span className="headingtext formarginleft">
                  Communication Preferences.
                </span>
              </p>
              <p className="darkpara">
                By creating an Account, you consent to receive electronic
                communications from Gems (e.g., via email or other types of
                messages). These communications may include notices about your
                Account (e.g., transactional information) and are part of your
                relationship with us. We may also send you promotional
                communications via email we think will be of interest to you.
                You understand that you are not required to provide this consent
                as a condition of using the Service and you may opt out of these
                communications through the Service or through your mobile
                device’s operating system (with the possible exception of
                important service announcements and administrative messages) by
                following the unsubscribe instructions provided or through your
                Account settings.
              </p>
              <p className="darkpara">
                6.
                <span className="headingtext formarginleft">
                  Indemnification
                </span>
              </p>
              <p className="darkpara">
                By agreeing to these Terms and accessing the Service, you agree,
                to the fullest extent permitted by applicable law, to indemnify,
                defend, and hold harmless Gems, and our respective past,
                present, and future employees, officers, directors, contractors,
                consultants, equity holders, suppliers, vendors, service
                providers, parent companies, subsidiaries, affiliates, agents,
                representatives, predecessors, successors, and assigns
                (individually and collectively, the “Gems Parties”), from and
                against all actual or alleged claims, damages, awards,
                judgments, losses, liabilities, obligations, taxes, penalties,
                interest, fees, expenses (including, without limitation,
                attorneys’ fees and expenses), and costs (including, without
                limitation, court costs, costs of settlement, and costs of
                pursuing indemnification and insurance), of every kind and
                nature whatsoever, whether known or unknown, foreseen or
                unforeseen, matured or unmatured, or suspected or unsuspected,
                in law or equity, whether in tort, contract, or otherwise
                (collectively, “Claims”), including, but not limited to, damages
                to property or personal injury, that are caused by, arise out of
                or are related to (a) your use or misuse of the Service (b) any
                Feedback you provide, (c) your violation or breach of any term
                of these Terms or applicable law, and (d) your violation of the
                rights of or obligations to a third party, including another
                user or third party, and (e) your negligence or wilful
                misconduct. You agree to promptly notify Gems of any Claims and
                cooperate with the Gems Parties in defending such Claims. You
                further agree that the Gems Parties shall have control of the
                defense or settlement of any Claims. THIS INDEMNITY IS IN
                ADDITION TO, AND NOT IN LIEU OF, ANY OTHER INDEMNITIES SET FORTH
                IN A WRITTEN AGREEMENT BETWEEN YOU AND GEMS. Your obligations
                under this Section 6 shall survive the termination, expiration,
                suspension, or rescission of these Terms and the termination,
                suspension, or cancellation of your Account or access to the
                Service for any reason.
              </p>

              <p className="darkpara">
                7.<span className="headingtext formarginleft">Disclaimers</span>
              </p>
              <p className="darkpara">
                YOUR ACCESS TO AND USE OF THE SERVICE IS AT YOUR OWN RISK. YOU
                UNDERSTAND AND AGREE THAT THE SERVICE IS PROVIDED ON AN “AS IS”
                AND “AS AVAILABLE” BASIS AND GEMS EXPRESSLY DISCLAIMS WARRANTIES
                OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. GEMS MAKE
                NO WARRANTY OR REPRESENTATION AND DISCLAIM ALL RESPONSIBILITY
                FOR WHETHER THE SERVICE: (A) WILL MEET YOUR REQUIREMENTS; (B)
                WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR
                ERROR-FREE BASIS; OR (C) WILL BE ACCURATE, RELIABLE, COMPLETE,
                LEGAL, OR SAFE. GEMS DISCLAIMS ALL OTHER WARRANTIES OR
                CONDITIONS, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION,
                IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT; (D) THAT THE
                TOKENS WILL BE SUITABLE FOR ANY PURPOSE, WILL ACCRUE OR HAVE ANY
                VALUE, ETC., OR THAT THEY WILL BE LISTED ON ANY CRYPTO EXCHANGE
                IN THE FUTURE. GEMS WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND
                FROM ANY ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR
                INFORMATION, CONTAINED ON THE SERVICE. WHILE GEMS ATTEMPTS TO
                MAKE YOUR ACCESS TO AND USE OF THE SERVICE SAFE, GEMS CANNOT AND
                DOES NOT REPRESENT OR WARRANT THAT THE SERVICE, CONTENT, OR
                TOKENS, OR ANY OTHER CONTENT LINKED TO THE TOKENS OR OTHERWISE
                PROVIDED VIA ONE OF THE PROJECTS WHOSE TOKENS AER AVAILABLE FOR
                YOU TO PURCHASE VIA THE PLATFORM ARE FREE OF VIRUSES OR OTHER
                HARMFUL COMPONENTS. WE CANNOT GUARANTEE THE SECURITY OF ANY DATA
                THAT YOU DISCLOSE ONLINE. NO ADVICE OR INFORMATION, WHETHER ORAL
                OR OBTAINED FROM THE GEMS PARTIES OR THROUGH THE SERVICE, WILL
                CREATE ANY WARRANTY OR REPRESENTATION NOT EXPRESSLY MADE HEREIN.
                YOU ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION
                AND DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD GEMS
                RESPONSIBLE FOR ANY BREACH OF SECURITY.
              </p>
              <p className="darkpara">
                WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND
                TAKE NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR,
                ANY USE OF OR LOSS OF USE OF TOKENS, CONTENT, AND/OR CONTENT
                LINKED TO OR ASSOCIATED WITH OR OTHERWISE PROVIDED VIA ONE OF
                THE PROJECTS WHOSE TOKENS ARE AVAILABLE FOR YOU TO PURCHASE VIA
                THE PLATFORM, INCLUDING BUT NOT LIMITED TO ANY LOSSES, DAMAGES,
                OR CLAIMS ARISING FROM: (A) USER ERROR, INCORRECTLY CONSTRUCTED
                TRANSACTIONS, OR MISTYPED ADDRESSES; (B) SERVER FAILURE OR DATA
                LOSS; (C) UNAUTHORIZED ACCESS OR USE; (D) ANY UNAUTHORIZED
                THIRD-PARTY ACTIVITIES, INCLUDING WITHOUT LIMITATION THE USE OF
                VIRUSES, PHISHING, BRUTEFORCING OR OTHER MEANS OF ATTACK AGAINST
                THE SERVICE OR TOKENS.
              </p>
              <p className="darkpara">
                NO GEMS PARTY IS RESPONSIBLE OR LIABLE FOR ANY SUSTAINED LOSSES
                OR INJURY DUE TO VULNERABILITY OR ANY KIND OF FAILURE, ABNORMAL
                BEHAVIOR OF SOFTWARE (E.G., WALLET, SMART CONTRACT), BLOCKCHAINS
                OR ANY OTHER FEATURES OF THE TOKENS. NO GEMS PARTY IS
                RESPONSIBLE FOR LOSSES OR INJURY DUE TO LATE REPORTS BY
                DEVELOPERS OR REPRESENTATIVES (OR NO REPORT AT ALL) OF ANY
                ISSUES WITH THE BLOCKCHAIN SUPPORTING THE TOKENS, INCLUDING
                FORKS, TECHNICAL NODE ISSUES OR ANY OTHER ISSUES HAVING LOSSES
                OR INJURY AS A RESULT.
              </p>
              <p className="darkpara">
                Some jurisdictions do not allow the exclusion of implied
                warranties in contracts with consumers, so the above exclusion
                may not apply to you.
              </p>
              <p className="darkpara">
                8.
                <span className="headingtext formarginleft">
                  Assumption of Risk.
                </span>
              </p>
              <p className="darkpara">You accept and acknowledge, that:</p>
              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> The value
                of a Token is subjective. Prices of Tokens are subject to
                volatility and fluctuations in the price of cryptocurrency can
                also materially and adversely affect Token prices. You
                acknowledge that you fully understand this subjectivity and
                volatility and that you may lose money.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> You are
                responsible for any fees related to use of the Service, if any,
                including for actions you take on the blockchain, regardless of
                whether a successful transaction occurs, and that such fees are
                final and irreversible.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> A lack of
                use or public interest in the creation and development of
                distributed ecosystems could negatively impact the development
                of those ecosystems and related applications, and could
                therefore also negatively impact the potential utility of the
                Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> The
                regulatory regime governing blockchain technologies, tokens,
                cryptocurrency, and other crypto-based items is uncertain, and
                new regulations or policies may materially adversely affect the
                development of the Service and the utility of the Tokens.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span> You are
                solely responsible for determining what, if any, taxes apply to
                your transactions and to withhold, collect, report, and remit
                the correct amounts of taxes to the appropriate tax authorities.
                Gems is not responsible for determining, withholding,
                collecting, reporting, or remitting any taxes that apply to your
                Tokens or the sale/purchase thereof.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span> We do not
                have ownership or control of the smart contracts deployed by
                third parties, and are not responsible and make no guarantees
                regarding their operation and functionality.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">g.</span> We do not
                control the public blockchains that you are interacting with and
                we do not control certain smart contracts and protocols that may
                be integral to your ability to complete transactions on these
                public blockchains. Additionally, blockchain transactions are
                irreversible and Gems has no ability to reverse any transactions
                on the blockchain.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">h.</span> There are
                risks associated with using Internet and blockchain based
                products, including, but not limited to, the risk associated
                with hardware, software, and Internet connections, the risk of
                malicious software introduction, and the risk that third parties
                may obtain unauthorized access to your third-party wallet or
                Account. You accept and acknowledge that Gems will not be
                responsible for any communication failures, disruptions, errors,
                distortions or delays you may experience when using the Service
                or any Blockchain network, however caused.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">i.</span> The
                Service may rely on third-party platforms and/or vendors. If we
                are unable to maintain a good relationship with such platform
                providers and/or vendors; if the terms and conditions or pricing
                of such platform providers and/or vendors change; if we violate
                or cannot comply with the terms and conditions of such platforms
                and/or vendors; or if any of such platforms and/or vendors loses
                market share or falls out of favor or is unavailable for a
                prolonged period of time, access to and use of the Service may
                be directly affected.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">j.</span>IF YOU HAVE
                A DISPUTE WITH ANY LEADERS OR PROJECT TEAM, YOU RELEASE US FROM
                CLAIMS, DEMANDS, AND DAMAGES OF EVERY KIND AND NATURE, KNOWN AND
                UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH SUCH
                DISPUTES. IN ENTERING INTO THIS RELEASE YOU EXPRESSLY WAIVE ANY
                PROTECTIONS (WHETHER STATUTORY OR OTHERWISE) THAT WOULD
                OTHERWISE LIMIT THE COVERAGE OF THIS RELEASE TO INCLUDE THOSE
                CLAIMS WHICH YOU MAY KNOW OR SUSPECT TO EXIST IN YOUR FAVOR AT
                THE TIME OF AGREEING TO THIS RELEASE.
              </p>
              <p className="darkpara">
                9.
                <span className="headingtext formarginleft">
                  Limitation of Liability.
                </span>
              </p>
              <p className="darkpara">
                TO THE FULLEST EXTENT PERMITTED BY LAW, YOU AGREE THAT IN NO
                EVENT WILL GEMS BE LIABLE TO YOU OR ANY THIRD PARTY (A) FOR ANY
                LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
                INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES ARISING FROM THESE
                TERMS OR THE SERVICE, PRODUCTS OR THIRD-PARTY SITES AND
                PRODUCTS, OR FOR ANY DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF
                PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE,
                LOSS OF GOODWILL, OR LOSS OF DATA, AND WHETHER CAUSED BY STRICT
                LIABILITY OR TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR
                OTHERWISE, EVEN IF FORESEEABLE AND EVEN IF GEMS OR ITS SERVICE
                PROVIDERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES;
                OR (B) FOR ANY OTHER CLAIM, DEMAND, OR DAMAGES WHATSOEVER
                RESULTING FROM OR ARISING OUT OF OR IN CONNECTION WITH THESE
                TERMS OF THE DELIVERY, USE, OR PERFORMANCE OF THE SERVICE.
              </p>
              <p className="darkpara">
                NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, TO
                THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE
                MAXIMUM AGGREGATE LIABILITY OF GEMS ARISING OUT OF OR IN ANY WAY
                RELATED TO THESE TERMS, THE ACCESS TO AND USE OF THE SERVICE,
                EXCEED THE GREATER OF (I) ONE HUNDRED U.S. DOLLARS (US$100) OR
                (II) THE AGGREGATE AMOUNT RECEIVED BY GEMS FOR ITS SERVICE TO
                YOU DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE
                EVENT GIVING RISE TO THE CLAIM AND DIRECTLY RELATING TO THE
                ITEMS THAT ARE THE SUBJECT OF THE CLAIM. THE FOREGOING
                LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF
                ITS ESSENTIAL PURPOSE.
              </p>
              <p className="darkpara">
                10.
                <span className="headingtext formarginleft">Termination</span>
              </p>
              <p className="darkpara">
                If you breach any of the provisions of these Terms, all licenses
                granted by Gems will terminate automatically. Additionally,
                notwithstanding anything contained in these Terms, we reserve
                the right, with or without notice and in our sole discretion, to
                suspend, restrict, disable, terminate, or delete your Account
                and/or your ability to access or use the Service (or any part of
                the foregoing) at any time and for any or no reason, and you
                acknowledge and agree that we shall have no liability or
                obligation to you in such event and that you will not be
                entitled to a refund of any amounts that you have already paid
                to us. If we terminate your Account or restrict your access or
                use of the Service, you retain ownership of your Tokens. You may
                still access your Tokens through public blockchains and other
                web3 wallets, platforms, and/or websites. All sections which by
                their nature should survive the termination of these Terms shall
                continue in full force and effect subsequent to and
                notwithstanding any termination of these Terms by Gems or you.
                Termination will not limit any of Gems’s other rights or
                remedies at law or in equity. You agree that a breach of these
                Terms will cause irreparable injury to Gems for which monetary
                damages would not be an adequate remedy and Gems shall be
                entitled to equitable relief in addition to any remedies it may
                have hereunder or at law without a bond, other security, or
                proof of damages.
              </p>
              <p className="darkpara">
                11.
                <span className="headingtext formarginleft">
                  Dispute Resolution; Mandatory Binding Arbitration; Class
                  Action Waiver.
                </span>
              </p>
              <p className="darkpara">
                PLEASE READ THIS SECTION CAREFULLY. IT REQUIRES YOU AND GEMS TO
                RESOLVE DISPUTES THROUGH FINAL AND BINDING ARBITRATION ON AN
                INDIVIDUAL BASIS AND LIMITS THE MANNER IN WHICH YOU CAN SEEK
                RELIEF FROM GEMS. BY AGREEING TO THESE TERMS, YOU AND GEMS WAIVE
                THE RIGHT TO A TRIAL BY JURY AND TO PARTICIPATE IN ANY CLASS
                ACTION OR REPRESENTATIVE PROCEEDING.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">a.</span> Informal
                Resolution. Before initiating any formal proceeding, you and
                Gems agree to attempt in good faith to resolve any dispute,
                claim, or controversy arising out of or relating to these Terms
                or the Service (each, a “Dispute”) through informal
                negotiation. A party seeking to commence a Dispute must first
                send a written notice describing the nature and basis of the
                Dispute and the relief sought to the other party (to Gems at{" "}
                <a href="mailto: Info@gems.vip">Info@gems.vip</a>). The parties
                shall attempt in good faith to resolve the Dispute within
                thirty (30) days after delivery of such notice. If the Dispute
                is not resolved within that period, either party may commence
                arbitration in accordance with this Section 11.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">b.</span> Agreement
                to Arbitrate. You and Gems agree that any and all Disputes,
                including the validity, scope, interpretation, enforceability,
                or breach of these Terms or this arbitration agreement, shall
                be resolved exclusively by final and binding arbitration
                administered by the Hong Kong International Arbitration Centre
                (the “HKIAC”) under the HKIAC Administered Arbitration Rules
                then in force (the “Rules”), which Rules are deemed to be
                incorporated by reference into this Section. The seat of
                arbitration shall be Hong Kong. The arbitration shall be
                conducted in English by a sole arbitrator appointed in
                accordance with the Rules. The arbitral award shall be final
                and binding on the parties and may be entered or enforced in
                any court of competent jurisdiction. The arbitrator shall have
                authority to grant any remedy or relief that a court of
                competent jurisdiction could order or grant, including
                provisional or injunctive relief, except as otherwise limited
                by this Section.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">c.</span> Class
                Action and Representative Action Waiver. YOU AND GEMS EACH
                AGREE THAT ANY DISPUTE SHALL BE BROUGHT AND CONDUCTED SOLELY IN
                YOUR INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER
                IN ANY PURPORTED CLASS, COLLECTIVE, CONSOLIDATED,
                REPRESENTATIVE, OR PRIVATE-ATTORNEY-GENERAL ACTION OR
                PROCEEDING. The arbitrator may not consolidate the claims of
                more than one person or party and may not preside over any form
                of class, collective, consolidated, or representative
                proceeding. If a court or arbitrator determines that this
                class-action and representative-action waiver is unenforceable
                with respect to any claim or remedy sought, then that claim or
                remedy (and only that claim or remedy) shall be severed from
                arbitration and brought in a court of competent jurisdiction in
                Hong Kong, while all other claims and remedies shall remain
                subject to arbitration on an individual basis.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">d.</span> Jury
                Trial Waiver. To the fullest extent permitted by applicable
                law, you and Gems each knowingly, voluntarily, and
                intentionally waive any right to a trial by jury in any action,
                proceeding, or counterclaim arising out of or relating to these
                Terms, the Service, or any Dispute.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">e.</span>{" "}
                Exceptions; Carve-Outs. Notwithstanding the foregoing, either
                party may (i) bring an individual action in a small-claims
                court of competent jurisdiction for any Dispute within that
                court’s jurisdictional limits; (ii) seek injunctive or other
                equitable relief in any court of competent jurisdiction
                (including, without limitation, the courts of Hong Kong as
                provided in Section 12) to protect intellectual property
                rights, confidential information, or to enforce compliance with
                applicable sanctions, anti-money-laundering, or other
                regulatory obligations; and (iii) bring a claim for enforcement
                of an arbitral award in any court of competent jurisdiction.
              </p>
              <p className="darkpara">
                <span className="headingtext formarginleft">f.</span>{" "}
                Severability of this Section. If any portion of this Section 11
                (other than the class-action and representative-action waiver
                in subsection (c), which is addressed separately therein) is
                found to be unenforceable, the unenforceable portion shall be
                severed and the remainder of this Section 11 shall remain in
                full force and effect.
              </p>
              <p className="darkpara">
                12.<span className="headingtext formarginleft">General</span>
              </p>
              <p className="darkpara">
                These Terms are governed by the laws of Hong Kong, excluding
                rules as to choice and conflicts of law and the competent courts
                in Hong Kong will have exclusive jurisdiction. If any part of
                these Terms is deemed unlawful, void or for any reason
                unenforceable, then that provision shall be deemed to be
                severable from the rest of these Terms and shall not affect the
                validity and enforceability of any of the remaining provisions
                of these Terms. In such cases, the part deemed invalid or
                unenforceable shall be construed in a manner consistent with
                applicable law to reflect, as closely as possible, the original
                intent of the parties. No waiver by us of a breach of any of the
                provisions of terms of these Terms shall be construed as a
                waiver of any preceding or succeeding breach of any of the
                provisions of these Terms. Nothing in these Terms shall be
                construed as creating any agency, partnership, trust
                arrangement, fiduciary relationship or any other form of joint
                enterprise between you and Gems. These Terms contain the entire
                agreement between Gems and you relating to your use of the
                Services and supersedes any and all prior agreements between
                Gems and you in relation to the same. You confirm that, in
                agreeing to accept these Terms, you have not relied on any
                representation except as has expressly been made by Gems in
                these Terms. You may not assign your rights or delegate your
                obligations under these Terms without Gems’ prior written
                consent. Any purported assignment contrary to this section will
                be null and void. Gems may assign its obligations hereunder.
                Except as otherwise provided herein, these Terms are intended
                solely for the benefit of the parties and are not intended to
                confer third-party beneficiary rights upon any other person or
                entity.
              </p>
              <p className="darkpara">
                In addition to the implementation of KYT (Know Your
                Transaction), a KYB (Know Your Business) process will also be
                enacted, facilitated by a trusted third-party service provider.
                This process will ensure thorough business verification for all
                entities interacting with the platform, supporting our
                compliance with international regulations. Furthermore, any
                funds or transactions received from jurisdictions classified as
                "blacklisted" or high-risk countries will be subject to enhanced
                scrutiny, including the reporting of any suspicious activities
                or transactions to the relevant authorities.
              </p>
            </div>
          </div>

          <div className="checkboxmainnnnnn">
            <label class="checkbox" for="ch1">
              <input
                type="checkbox"
                onChange={inputField1Handler2}
                id="ch1"
              ></input>
              <span class="checkmark"></span>
            </label>
            <p className="checkboxpara">
              I have carefully reviewed the Private Sale Agreement, including
              its disclaimers, and fully agree to abide by its terms and
              conditions.
            </p>
          </div>

          {/* {cheked && ( */}
          <div className="checkboxmainnnnnn">
            <label class="checkbox" for="ch2">
              <input type="checkbox" id="ch2" onChange={inputField1Handler3} />
              <span class="checkmark"></span>
            </label>
            <p className="checkboxpara">
              I hereby confirm that I am not a citizen or a resident of the
              United States of America or the State of Israel.
            </p>
          </div>
          {/* )} */}
          {/* {cheked1 ? ( */}
          <div className="checkboxmainnnnnn">
            <label class="checkbox" for="ch3">
              <input type="checkbox" id="ch3" onChange={inputField1Handler4} />
              <span class="checkmark"></span>
            </label>
            <p className="checkboxpara">
              I agree to receive communication and marketing emails from Gems
            </p>
          </div>
          {/* ) : (
            ""
          )} */}
          <p className="inputpara">Email Address</p>
          <div className="material-textfield">
            <input
              type="text"
              placeholder="Enter your email address"
              onChange={inputField1Handler5}
              value={inputFeild6}
              className={isValidMail ? "" : "errorinput"}
            />
            {isCheckingEmail && (
              <div className="checkmain">
                <img
                  src="/assets/spinner.svg"
                  alt="spinnerimg"
                  className="spinnerimg"
                />
                <p className="checkpara">Checking...</p>
              </div>
            )}
            {isEmailVerified !== null &&
              (isEmailVerified ? (
                <div className="verifymain">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_2291_3069)">
                      <circle
                        cx="6.99963"
                        cy="6.99963"
                        r="6.99963"
                        fill="#329879"
                      />
                      <path
                        d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2291_3069">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p className="verifypara">Email Verified</p>
                </div>
              ) : (
                <div className="notmain">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_935_5646)">
                      <circle
                        cx="6.99963"
                        cy="6.99963"
                        r="6.99963"
                        fill="#FC4F52"
                      />
                      <path
                        d="M11 4.04473L8.04473 7L11 9.95527L9.95527 11L7 8.04473L4.04473 11L3 9.95527L5.95527 7L3 4.04473L4.04473 3L7 5.95527L9.95527 3L11 4.04473Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_935_5646">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p className="notpara">Email not verified</p>
                </div>
              ))}
            {!isValidMail && <p className="errorpara">Invalid format</p>}
          </div>
          {cheked && checkedNew1 && cheked2 && cheked1 ? (
            isEmailVerified !== null && account ? (
              isEmailVerified ? (
                <button onClick={() => redirectTo()} className="continuebutton">
                  Continue
                </button>
              ) : (
                <button
                  onClick={() => {
                    handleClose2(true);
                    setShowVerify(true);
                  }}
                  className="continuebutton"
                >
                  Continue to Email Verification
                </button>
              )
            ) : (
              <button
                onClick={account ? userLogin : handleShow1}
                className="continuebutton"
              >
                {account ? "Check Email Verification" : "Connect Wallet"}
              </button>
            )
          ) : (
            <button className="disablebutton">
              {account ? "Continue" : "Connect Wallet"}
            </button>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        className="stakingmodal common-modal-style followusonx-modal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static" // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <p className="para">
              Enter your email address to receive a 6-digit verification code.
              Then, enter the code below to verify your email and continue.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <div className="material-textfield">
                  <input
                    type="text"
                    placeholder="Enter your email address"
                    onChange={inputField1Handler5}
                    value={inputFeild6}
                  />
                  <a
                    href="#"
                    className={`btn-send ${!isValidMail || isResendDisabled ? "disabled" : ""
                      }`}
                    onClick={handleSendCode}
                    style={{
                      pointerEvents: isResendDisabled ? "none" : "auto",
                      opacity: !isValidMail || isResendDisabled ? 0.5 : 1,
                    }}
                  >
                    {isResendDisabled
                      ? `Resend in ${resendTimer}s`
                      : codeSentOnce
                        ? "Resend "
                        : "Send Code"}
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{
                opacity: showOtpInput ? 1 : 1,
                pointerEvents: showOtpInput ? "auto" : "none",
              }}
            >
              <div
                className="option-field"
                style={{ marginTop: "25px", marginBottom: "0" }}
              >
                <label style={{ color: "var(--text-collor)" }}>
                  Verification Code
                </label>
                <div className="inside-input">
                  <div
                    className="material-textfield"
                    style={{ marginBottom: "0" }}
                  >
                    <input
                      type="text"
                      placeholder="Enter 6-digit code here"
                      value={otp}
                      onChange={(e) => {
                        setOtp(e.target.value);
                        setIsOtpValid(true);
                      }}
                      className={isOtpValid ? "" : "errorinput"}
                    />
                    {!isOtpValid && (
                      <p className="errorpara">
                        Invalid email verification code
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="twice-btnsss">
                <button
                  className={`greybtn sscscscscscsc ${otp.length !== 6 ? "disabled" : ""
                    }`}
                  style={{
                    marginTop: "28px",
                    opacity: otp.length < 6 ? 0.5 : 1, // 👈 add this
                  }}
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 6}
                >
                  Verify Code
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="twice-btns">
            <button className="forhideee" onClick={connectMetaMask1}>
              <img src="\assets\metamask.svg" alt="img" className="img-fluid" />
              <h6>Metamask</h6>
            </button>
            {/* {TomiPayBol == 'true' ?
              <button onClick={trustWallet}>
                <img
                  src="\assets\tomiPAYLogo.png"
                  alt="img"
                  className="img-fluid payyy"
                />
                <h6>tomiPAY</h6>
              </button>
              : */}
            <button onClick={trustWallet}>
              <img
                src="\assets\walletconnect.svg"
                alt="img"
                className="img-fluid"
              />
              <h6>WalletConnect</h6>
            </button>

            {/* } */}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="leadercodemodal"
        show={show11}
        onHide={handleClose11}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maininnercontent">
            <div className="image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
              >
                <rect width="70" height="70" rx="35" fill="#02171D" />
                <path
                  d="M24.1756 19.0938L15.1201 28.8991V35.2588L35.0746 55.2137L55.0201 35.2695V32.7014H30.6565L32.3449 38.0036H43.6807L35.0728 46.6158L21.3996 32.9368L28.3423 25.4285H41.8033L44.7701 28.6405H53.9004V27.6881L45.9629 19.0938H24.1756Z"
                  fill="#30F1B6"
                />
              </svg>
            </div>
            <h2>Don’t have a leader code ?</h2>
            <p>
              To participate in the GEMS private sale, you need a valid leader
              code.
            </p>
            <p>
              If you don’t have one yet, you’re invited to join the official
              <span> GEMS Telegram group, </span> where leader codes are shared
              with eligible participants.
            </p>
            <p>
              Please make sure to follow the group guidelines to receive your
              code.
            </p>
            <button className="join" onClick={joinTelegramHandler}>
              Join GEMS Telegram Group
            </button>
            <button
              className="cancle"
              onClick={() => {
                // handleShow12();
                handleClose11();
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="leadercodemodal newleadercodemodal"
        show={show12}
        onHide={handleClose12}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Hold On!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="maininnercontent">
            <div className="image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="70"
                height="70"
                viewBox="0 0 70 70"
                fill="none"
              >
                <rect width="70" height="70" rx="35" fill="#02171D" />
                <path
                  d="M24.1756 19.0938L15.1201 28.8991V35.2588L35.0746 55.2137L55.0201 35.2695V32.7014H30.6565L32.3449 38.0036H43.6807L35.0728 46.6158L21.3996 32.9368L28.3423 25.4285H41.8033L44.7701 28.6405H53.9004V27.6881L45.9629 19.0938H24.1756Z"
                  fill="#30F1B6"
                />
              </svg>
            </div>
            <h2>Wait! Don't Miss Out</h2>
            <p className="mainpara">
              Get your exclusive leader code to access <br /> GEMS presale
              rounds
            </p>
            <button className="join" onClick={joinTelegramHandler}>
              Join Telegram
            </button>
            <h6 onClick={handleClose12} style={{ cursor: "pointer" }}>
              No thanks, I'll continue without a code
            </h6>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="leadercodemodal access-kai-modal"
        show={showKaiModal}
        onHide={() => setShowKaiModal(false)}
        centered
      >
        <img src="\assets\kaimodalbg.png" alt="img" className="img-fluid kaimodalbg" />
        <Modal.Header closeButton>
          <Modal.Title>
            <img src="\assets\kai-icon.svg" alt="img" className="img-fluid" />
            Get Your KAI Access Code
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="main-content">
            <p className="para-first">KAI is granting eligible users an access code to join the private sale.</p>
            <p className="sec-para">Generate your personal code and use it to continue.</p>
            <div className="twice-btn-box">
              <button className="btn-green" onClick={handleGenerateAccessCode}><span className="icon-left"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M5.797 9.04165C5.74492 8.83977 5.63969 8.65554 5.49227 8.50812C5.34485 8.3607 5.16062 8.25548 4.95875 8.2034L1.38 7.28057C1.31894 7.26324 1.2652 7.22646 1.22694 7.17583C1.18867 7.12519 1.16797 7.06345 1.16797 6.99998C1.16797 6.93651 1.18867 6.87478 1.22694 6.82414C1.2652 6.7735 1.31894 6.73673 1.38 6.7194L4.95875 5.79598C5.16055 5.74395 5.34473 5.63882 5.49215 5.49151C5.63956 5.34419 5.74483 5.16008 5.797 4.95832L6.71983 1.37957C6.73698 1.31827 6.77372 1.26427 6.82443 1.2258C6.87515 1.18733 6.93705 1.1665 7.0007 1.1665C7.06436 1.1665 7.12626 1.18733 7.17698 1.2258C7.22769 1.26427 7.26442 1.31827 7.28158 1.37957L8.20383 4.95832C8.25591 5.16019 8.36113 5.34442 8.50855 5.49184C8.65597 5.63926 8.8402 5.74449 9.04208 5.79657L12.6208 6.71882C12.6824 6.73579 12.7366 6.77249 12.7753 6.82328C12.814 6.87407 12.8349 6.93614 12.8349 6.99998C12.8349 7.06382 12.814 7.1259 12.7753 7.17669C12.7366 7.22748 12.6824 7.26417 12.6208 7.28115L9.04208 8.2034C8.8402 8.25548 8.65597 8.3607 8.50855 8.50812C8.36113 8.65554 8.25591 8.83977 8.20383 9.04165L7.281 12.6204C7.26384 12.6817 7.22711 12.7357 7.17639 12.7742C7.12568 12.8126 7.06377 12.8335 7.00012 12.8335C6.93647 12.8335 6.87456 12.8126 6.82385 12.7742C6.77314 12.7357 6.7364 12.6817 6.71925 12.6204L5.797 9.04165Z" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.668 1.75V4.08333" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.8333 2.91675H10.5" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.33203 9.9165V11.0832" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.91667 10.5H1.75" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
              </svg></span>Generate Access Code <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3.33203 8H12.6654" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 3.33325L12.6667 7.99992L8 12.6666" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg></button>
              <button className="btn-cancle" onClick={() => setShowKaiModal(false)}>Cancel</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="leadercodemodal access-kai-modal loading-modal"
        show={showKaiLoadingModal}
        centered
      >
        <img src="\assets\kaimodalbg.png" alt="img" className="img-fluid kaimodalbg" />
        <Modal.Body>
          <div className="main-content">
            <div className="loader-parent">
              <svg className="loading-circle" xmlns="http://www.w3.org/2000/svg" width="87" height="90" viewBox="0 0 87 90" fill="none">
                <path d="M13.1455 14.7991C11.8627 13.4467 11.9118 11.2994 13.3565 10.1216C19.9989 4.70633 28.0709 1.28488 36.6309 0.296895C46.3118 -0.82046 56.0938 1.23502 64.5062 6.1543C72.9186 11.0736 79.5067 18.5908 83.2801 27.5757C87.0535 36.5607 87.8082 46.5277 85.4308 55.9784C83.0533 65.4291 77.6722 73.8526 70.0965 79.9826C62.5207 86.1125 53.1598 89.6175 43.421 89.9706C33.6823 90.3237 24.0921 87.5058 16.0923 81.9407C9.01871 77.0198 3.52661 70.1862 0.237248 62.2724C-0.478168 60.5512 0.494672 58.6363 2.26464 58.0519C4.0346 57.4674 5.92949 58.4362 6.66764 60.1478C9.48329 66.6766 14.0738 72.3138 19.947 76.3996C26.7469 81.13 34.8985 83.5252 43.1765 83.225C51.4544 82.9249 59.4112 79.9456 65.8506 74.7352C72.29 69.5248 76.8639 62.3648 78.8848 54.3317C80.9056 46.2986 80.2641 37.8266 77.0567 30.1894C73.8493 22.5522 68.2493 16.1626 61.0988 11.9812C53.9483 7.79979 45.6336 6.05263 37.4048 7.00238C30.2974 7.82271 23.5859 10.6167 18.0161 15.0361C16.5559 16.1947 14.4282 16.1515 13.1455 14.7991Z" fill="#329879" />
              </svg>
              <img src="\assets\kai-icon.svg" alt="img" className="img-fluid kai-icon" />
            </div>
            <h4>Generating your code...</h4>
            <p>This will only take a moment</p>
            <div className="loading-dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="leadercodemodal access-kai-modal access-generated-modal"
        show={showKaiGeneratedModal}
        onHide={() => setShowKaiGeneratedModal(false)}
        centered
      >
        <img src="\assets\kaimodalbg.png" alt="img" className="img-fluid kaimodalbg" />
        <Modal.Body>
          <div className="main-content">
            <img src="\assets\check-icon-modal.svg" alt="img" className="img-fluid" />
            <h4>Access Code Generated</h4>
            <p>Your personal KAI access code is ready. <br />
              Copy the code below and use it continue to the private sale </p>
            <div className="code-generated-parent">
              <div className="left">
                <p>YOUR ACCESS CODE</p>
                <h6>{KAI_ACCESS_CODE}</h6>
              </div>
              <button className="btn-copy" onClick={handleCopyCode}>
                {isCodeCopied ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M4 11L9 16L18 6" stroke="#329879" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M16.5 7.5625H9.625C8.48591 7.5625 7.5625 8.48591 7.5625 9.625V16.5C7.5625 17.6391 8.48591 18.5625 9.625 18.5625H16.5C17.6391 18.5625 18.5625 17.6391 18.5625 16.5V9.625C18.5625 8.48591 17.6391 7.5625 16.5 7.5625Z" stroke="#329879" strokeWidth="1.2" />
                    <path d="M14.4375 7.5625V5.5C14.4375 4.35875 13.5162 3.4375 12.375 3.4375H5.5C4.35875 3.4375 3.4375 4.35875 3.4375 5.5V12.375C3.4375 13.5162 4.35875 14.4375 5.5 14.4375H7.5625" stroke="#329879" strokeWidth="1.2" strokeLinecap="round" />
                  </svg>
                )}
                {isCodeCopied ? "Copied!" : "Copy"}
              </button>
            </div>
            <div className="twice-btn-box">
              <button className="btn-green" style={{ justifyContent: "center" }} onClick={() => { handleCopyCode(); setShowKaiGeneratedModal(false); }}>Copy Code & Continue</button>
              <button className="btn-cancle" onClick={() => setShowKaiGeneratedModal(false)}>Close</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Login;
